import { message } from "antd";
import axiosInstance from "../../helpers/axios";
import { responseDataFormate } from "../../helpers/bycrypt";
import { API_URL } from "../../helpers/utils";

interface GetLockDatesParams {
  year?: number;
  onSuccess?: (data: any[]) => void;
  onError?: () => void;
}

export const getLockDatesAPI =
  ({ year, onSuccess, onError }: GetLockDatesParams = {}) =>
  async (dispatch: any) => {
    try {
      const params = new URLSearchParams();
      if (year) params.set('year', String(year));
      const response = await axiosInstance.get(`${API_URL}/leave-lock-dates?${params.toString()}`);
      let result = responseDataFormate(response.data);
      if (result?.success) {
        onSuccess?.(result.data || []);
      } else {
        message.error(result?.message || "Failed to fetch lock dates");
        onError?.();
      }
    } catch (error: any) {
      console.error("Fetch lock dates error:", error);
      onError?.();
      const errorMessage =
        error?.response?.data?.message || "Unable to fetch lock dates";
      message.error(errorMessage);
    }
  };

interface CreateLockDateParams {
  payload: {
    lockDates: any[];
  };
  onSuccess?: (data: any) => void;
  onError?: () => void;
}

export const createLockDateAPI =
  ({ payload, onSuccess, onError }: CreateLockDateParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/leave-lock-dates`, payload);
      let result = responseDataFormate(response.data);
      if (result?.success) {
        message.success(result?.message || "Lock date(s) saved successfully");
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to save lock date(s)");
        onError?.();
      }
    } catch (error: any) {
      console.error("Create lock date error:", error);
      onError?.();
      const errorMessage =
        error?.response?.data?.message || "Unable to save lock date(s)";
      message.error(errorMessage);
    }
  };

interface DeleteLockDateParams {
  id: string;
  onSuccess?: (data: any) => void;
  onError?: () => void;
}

export const deleteLockDateAPI =
  ({ id, onSuccess, onError }: DeleteLockDateParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.delete(`${API_URL}/leave-lock-dates/${id}`);
      let result = responseDataFormate(response.data);
      if (result?.success) {
        message.success(result?.message || "Lock date deleted successfully");
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to delete lock date");
        onError?.();
      }
    } catch (error: any) {
      console.error("Delete lock date error:", error);
      onError?.();
      const errorMessage =
        error?.response?.data?.message || "Unable to delete lock date";
      message.error(errorMessage);
    }
  };
